import './LoiExecutedDocumentUploadModal.scss';
import React, { useRef, useState } from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import { Formik } from 'formik';
import Rodal from '../../../components/Rodal/Rodal';
import { FileSelector } from '../../../components/FileSelector/FileSelector';
import ButtonLoader from '../../../components/Layout/Buttons/ButtonLoader';
import { useStateSelector } from '../../../store/selectors';
import { uploadLoiExecutedDocument } from '../../../slices/marketplace/loi-preparation/loi-preparation-api';
import createNotification from '../../../utils/createNotification';

const LOI_EXECUTED_DOCUMENT_UPLOAD_MODAL_WIDTH = 650;

export interface LoiExecutedDocumentUploadModalProps {
    isVisible: boolean;
    onClose: () => void;
    engagementId: number;
    buyerId: number;
}

export const LoiExecutedDocumentUploadModal = (
    props: LoiExecutedDocumentUploadModalProps
) => {
    const formRef = useRef<any>();
    const axios = useStateSelector((state) => state.core.axios);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const resetState = () => {
        setSelectedFile(null);
        formRef.current?.resetForm();
    };

    const handleClose = () => {
        resetState();
        props.onClose();
    };

    const changeFileHandler = (file: File) => {
        if (file) {
            setSelectedFile(file);
            formRef.current.setFieldValue('sourceFile', file.name, true);
        }
    };

    const handleConfirm = async () => {
        if (!axios || !selectedFile) {
            return;
        }
        setIsSubmitting(true);
        try {
            await uploadLoiExecutedDocument(
                axios,
                props.engagementId,
                props.buyerId,
                selectedFile
            );
            createNotification(
                'Fully executed LOI document uploaded successfully.',
                'success'
            );
            resetState();
            props.onClose();
        } catch (err: unknown) {
            const message =
                err instanceof Error && err.message
                    ? err.message
                    : 'Could not upload the document. Please try again.';
            createNotification(message, 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="loi-executed-document-upload-modal-container">
            <Rodal
                visible={props.isVisible}
                onClose={handleClose}
                animation="slideUp"
                className="loi-executed-document-upload-modal"
                showMask={true}
                width={LOI_EXECUTED_DOCUMENT_UPLOAD_MODAL_WIDTH}
                showCloseButton={true}>
                <ModalHeader>
                    <b>Upload Fully Executed Document</b>
                </ModalHeader>
                <ModalBody>
                    <Formik
                        innerRef={formRef}
                        initialValues={{ sourceFile: '' }}
                        onSubmit={() => {}}>
                        {({ values }) => (
                            <FileSelector
                                extension=".pdf"
                                disabled={isSubmitting}
                                file={selectedFile}
                                setFile={changeFileHandler}
                                fileName={values.sourceFile}
                                downloadFile={() => {}}
                                setIsDocumentsHistoryPopupVisible={() => {}}
                                oldDocumentDetailsList={[]}
                            />
                        )}
                    </Formik>
                    <div className="d-flex justify-content-end buttons-container">
                        <button
                            className="btn btn-outline-secondary mr-2"
                            disabled={isSubmitting}
                            onClick={handleClose}>
                            Cancel
                        </button>
                        <ButtonLoader
                            buttonText={'Confirm'}
                            loaderButtonText={''}
                            isLoading={isSubmitting}
                            disabled={!selectedFile || isSubmitting}
                            onClick={handleConfirm}
                            className={'btn btn-primary'}
                        />
                    </div>
                </ModalBody>
            </Rodal>
        </div>
    );
};
